import { render } from "./WatchTournament.vue?vue&type=template&id=ea06038e&ts=true"
import script from "./WatchTournament.vue?vue&type=script&lang=ts"
export * from "./WatchTournament.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__